
import { createSlice } from '@reduxjs/toolkit';

const orgReportSlice = createSlice({
  name: 'orgReport',
  initialState: {
    data: null,
    totalRowCount: 0,
    loading: false,
    error: null,
  },
  reducers: {
    setOrgReportData: (state, action) => {
      state.data = action.payload;
      state.totalRowCount = action.payload.totalRowCount;
    },
    setOrgReportLoading: (state, action) => {
      state.loading = action.payload;
    },
    setOrgReportError: (state, action) => {
      state.error = action.payload;
    },
    clearOrgReport: (state) => {
      state.data = null;
      state.error = null;
    },
  },
});

export const { setOrgReportData, setOrgReportLoading, setOrgReportError, clearOrgReport } = orgReportSlice.actions;
export default orgReportSlice.reducer;
